
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { RebootRequestBody } from '../entities/reboot-commands-v2/models';
import { RebootResponsePayloadActual } from '../entities/reboot-commands-v2/types';
import { axiosInstance } from "../axios-instance";

class RebootConfig {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  rebootCommandForDevice(
    input: RebootRequestBody,
  ): Promise<AxiosResponse<RebootResponsePayloadActual>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<RebootResponsePayloadActual>(`${this.baseUrl}/queueRebootCommands`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }
}

export default RebootConfig;
